import { createAction } from '@ngrx/store';

const TAG = `[Auditing UI]`;

export const toggleSidebarAuditing = createAction('${TAG} Toggle Sidebar');
export const closeSidebarAuditing = createAction('${TAG} Close Sidebar');
